(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4380],{

/***/ 94380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ CodeRunDisplay; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/system/alert.tsx
var system_alert = __webpack_require__(56522);
// EXTERNAL MODULE: ./src/icons/index.tsx + 61 modules
var icons = __webpack_require__(63009);
// EXTERNAL MODULE: ./src/users/upsell.tsx
var upsell = __webpack_require__(1048);
// EXTERNAL MODULE: ./src/components/runner/code_run_display.module.css
var code_run_display_module = __webpack_require__(72734);
var code_run_display_module_default = /*#__PURE__*/__webpack_require__.n(code_run_display_module);
// EXTERNAL MODULE: ./src/components/system/pilltag.tsx
var pilltag = __webpack_require__(94390);
// EXTERNAL MODULE: ./src/components/system/pilltag_group.tsx
var pilltag_group = __webpack_require__(8681);
;// CONCATENATED MODULE: ./src/components/runner/summary.tsx



var Summary = function(param) {
    var summary = param.summary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(pilltag_group/* PillTagGroup */.s, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(pilltag/* PillTag */.j, {
                color: "greyLight",
                children: [
                    "Total tests: ",
                    summary.total
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(pilltag/* PillTag */.j, {
                color: summary.passed > 0 ? "green" : "greyLight",
                children: [
                    "Passed: ",
                    summary.passed
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(pilltag/* PillTag */.j, {
                color: summary.failed > 0 ? "red" : "greyLight",
                children: [
                    "Failed: ",
                    summary.failed
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/components/system/divider.tsx
var divider = __webpack_require__(34070);
// EXTERNAL MODULE: ./src/components/system/tabs.tsx
var tabs = __webpack_require__(88446);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/index.tsx
var utils = __webpack_require__(44868);
// EXTERNAL MODULE: ./src/components/runner/drawable_table.module.css
var drawable_table_module = __webpack_require__(75311);
var drawable_table_module_default = /*#__PURE__*/__webpack_require__.n(drawable_table_module);
;// CONCATENATED MODULE: ./src/components/runner/drawable_table.tsx



var DrawableTable = function(param) {
    var data = param.data;
    var isMatrix = Array.isArray(data[0]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        className: (drawable_table_module_default()).table,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        isMatrix && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                        Object.keys(data[0]).map(function(column) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: column
                            }, column);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                children: data.map(function(record, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            isMatrix && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: index
                            }),
                            Object.keys(record).map(function(column) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: record[column] === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (drawable_table_module_default())["null"],
                                        children: "NULL"
                                    }) : JSON.stringify(record[column])
                                }, column);
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
// A drawable table is an array of objects with the same keys, or an array of arrays (a matrix).
var isDrawableTable = function(rawData) {
    try {
        var data = JSON.parse(rawData);
        if (Array.isArray(data)) {
            if (data.length === 0) {
                throw new Error("Empty array");
            }
            data.forEach(function(item) {
                if (!(0,utils/* isObject */.Kn)(item)) {
                    throw new Error("Not an object");
                }
                if (Object.keys(item).length === 0) {
                    throw new Error("Not a table");
                }
                if (!(Object.keys(data[0]).length === Object.keys(item).length && Object.keys(data[0]).every(function(k) {
                    return item.hasOwnProperty(k);
                }))) {
                    throw new Error("Elements are not the same");
                }
            });
            return true;
        } else {
            throw new Error("Its not an array");
        }
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/charts/styles.tsx
var styles = __webpack_require__(38614);
// EXTERNAL MODULE: ./src/components/system/colors.tsx
var colors = __webpack_require__(47655);
// EXTERNAL MODULE: ./node_modules/victory-chart/es/victory-chart.js + 2 modules
var victory_chart = __webpack_require__(13808);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-theme/victory-theme.js + 2 modules
var victory_theme = __webpack_require__(6673);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-container/victory-container.js + 1 modules
var victory_container = __webpack_require__(3532);
// EXTERNAL MODULE: ./node_modules/victory-axis/es/victory-axis.js + 1 modules
var victory_axis = __webpack_require__(73091);
// EXTERNAL MODULE: ./node_modules/victory-group/es/victory-group.js + 1 modules
var victory_group = __webpack_require__(54878);
// EXTERNAL MODULE: ./node_modules/victory-area/es/victory-area.js + 2 modules
var victory_area = __webpack_require__(42371);
// EXTERNAL MODULE: ./src/components/runner/monte_carlo_simulation.module.css
var monte_carlo_simulation_module = __webpack_require__(53856);
var monte_carlo_simulation_module_default = /*#__PURE__*/__webpack_require__.n(monte_carlo_simulation_module);
;// CONCATENATED MODULE: ./src/components/runner/monte_carlo_simulation.tsx








var MonteCarloSimulation = function(param) {
    var success = param.success, expectedDistribution = param.expectedDistribution, outputDistribution = param.outputDistribution;
    var bucketNames;
    var getX;
    if (isDiscrete(expectedDistribution)) {
        // Discrete random variable.
        bucketNames = Object.fromEntries(expectedDistribution.map(function(bucket, i) {
            return [
                JSON.stringify(bucket.output),
                String.fromCharCode(65 + i)
            ];
        }));
        getX = function(bucket) {
            return bucketNames[JSON.stringify(bucket.output)];
        };
    } else {
        // Continuous random variable.
        getX = function(bucket) {
            return (bucket.output_from + bucket.output_to) / 2;
        };
    }
    var dataExpected = expectedDistribution.map(function(bucket) {
        return {
            x: getX(bucket),
            y: bucket.weight
        };
    });
    var dataOutput = outputDistribution.map(function(bucket) {
        return {
            x: getX(bucket),
            y: bucket.weight
        };
    });
    var outputColor = success ? "green" : "red";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (monte_carlo_simulation_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(victory_chart/* VictoryChart */.k, {
                theme: victory_theme/* VictoryTheme.material */.J.material,
                width: 420,
                height: 220,
                padding: {
                    left: 10 + (dataExpected[0].x < 0 ? 0 : 40),
                    top: 0,
                    bottom: 30,
                    right: 10
                },
                domainPadding: {
                    y: 20
                },
                containerComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_container/* VictoryContainer */._, {
                    responsive: true
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_axis/* VictoryAxis */.E, {
                        style: styles/* axisStyle */.TH
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_axis/* VictoryAxis */.E, {
                        dependentAxis: true,
                        style: styles/* axisStyle */.TH
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(victory_group/* VictoryGroup */.G, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_area/* VictoryArea */.b, {
                                data: dataExpected,
                                interpolation: "basis",
                                style: {
                                    data: {
                                        fill: colors/* cssColorValues.orange */.b.orange,
                                        fillOpacity: 0.2,
                                        stroke: colors/* cssColorValues.orange */.b.orange,
                                        strokeWidth: 2,
                                        strokeOpacity: 1
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(victory_area/* VictoryArea */.b, {
                                data: dataOutput,
                                interpolation: "basis",
                                style: {
                                    data: {
                                        fill: colors/* cssColorValues */.b[outputColor],
                                        fillOpacity: 0.2,
                                        stroke: colors/* cssColorValues */.b[outputColor],
                                        strokeWidth: 2,
                                        strokeOpacity: 0.5
                                    }
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (monte_carlo_simulation_module_default()).buckets,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,utils/* classNames */.AK)([
                            (monte_carlo_simulation_module_default()).legend,
                            (monte_carlo_simulation_module_default()).expected
                        ]),
                        children: "Expected distribution"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,utils/* classNames */.AK)([
                            (monte_carlo_simulation_module_default()).legend,
                            (monte_carlo_simulation_module_default())[outputColor]
                        ]),
                        children: "Your distribution"
                    }),
                    bucketNames && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Buckets:",
                            Object.entries(bucketNames).map(function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), output = _param[0], bucketName = _param[1];
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: bucketName
                                        }),
                                        ": ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            children: output
                                        })
                                    ]
                                }, bucketName);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var isMonteCarloSimulation = function(rawExpectedDistribution, rawOutputDistribution) {
    return isDistribution(rawExpectedDistribution) && isDistribution(rawOutputDistribution);
};
var isDistribution = function(rawDistribution) {
    try {
        var distribution = JSON.parse(rawDistribution);
        if (!Array.isArray(distribution)) return false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = distribution[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var bucket = _step.value;
                var keys = Object.keys(bucket);
                if (!keys.includes("weight")) return false;
                if (!keys.includes("output") && !(keys.includes("output_from") && keys.includes("output_to"))) {
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } catch (e) {
        return false;
    }
    return true;
};
var isDiscrete = function(distribution) {
    // We can determine if it's a discrete distribution by counting the unique outputs of
    // each bucket and checking it matches with the total amount of buckets.
    return (0,_to_consumable_array/* default */.Z)(new Set(distribution.map(function(param) {
        var output = param.output;
        return output;
    }))).length === distribution.length;
};

// EXTERNAL MODULE: ./src/components/runner/output_block.module.css
var output_block_module = __webpack_require__(34828);
var output_block_module_default = /*#__PURE__*/__webpack_require__.n(output_block_module);
;// CONCATENATED MODULE: ./src/components/runner/output_block.tsx


var OutputBlock = function(param) {
    var label = param.label, status = param.status, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (output_block_module_default())[status],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (output_block_module_default()).label,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (output_block_module_default()).output,
                children: typeof children === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (output_block_module_default()).verbatim,
                    children: children
                }) : children
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/runner/test_case_result.module.css
var test_case_result_module = __webpack_require__(31360);
var test_case_result_module_default = /*#__PURE__*/__webpack_require__.n(test_case_result_module);
;// CONCATENATED MODULE: ./src/components/runner/test_case_result.tsx












// TODO: Show testCase.message when we enhance them to return more specific info about the failure.
var TestCaseResult = function(param) {
    var index = param.index, testCase = param.testCase, tmp = param.collapsed, initialCollapsed = tmp === void 0 ? false : tmp;
    var ref = (0,react.useState)(initialCollapsed), collapsed = ref[0], setCollapsed = ref[1];
    var inputTabs = (0,react.useMemo)(function() {
        var tabs = [];
        if (testCase.table_data !== "") {
            try {
                var tables = JSON.parse(testCase.table_data);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(tables)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
                        tabs.push({
                            label: key,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawableTable, {
                                data: value
                            })
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } catch (e) {
                console.log(e);
                return tabs;
            }
        //the tables are in object where the key is the table name and the value is the table
        }
        if (testCase.func_args !== "") {
            try {
                var funcArguments = JSON.parse(testCase.func_args);
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // arguments are of type string[]
                    for(var _iterator1 = funcArguments.entries()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _value1 = (0,_sliced_to_array/* default */.Z)(_step1.value, 2), index = _value1[0], value1 = _value1[1];
                        if (value1.length === 0) {
                            continue;
                        }
                        tabs.push({
                            label: "argument #".concat(index + 1),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    " ",
                                    isDrawableTable(JSON.stringify(value1)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawableTable, {
                                        data: value1
                                    }) : JSON.stringify(value1)
                                ]
                            })
                        });
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            } catch (e1) {
                console.log(e1);
                return tabs;
            }
        }
        return tabs;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,utils/* classNames */.AK)([
            (test_case_result_module_default()).container,
            testCase.success ? (test_case_result_module_default()).success : (test_case_result_module_default()).error
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (test_case_result_module_default()).header,
                onClick: function() {
                    return setCollapsed(!collapsed);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(divider/* Divider */.i, {
                    align: "left",
                    size: "sm",
                    children: [
                        testCase.success ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckmarkIcon */.KM, {
                            color: "green"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                            color: "red"
                        }),
                        " ",
                        testCase.playground ? "Playground" : "Test case #".concat(index + 1),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (test_case_result_module_default()).expandCTA,
                            children: [
                                "(",
                                collapsed ? "view" : "hide",
                                " details)"
                            ]
                        })
                    ]
                })
            }),
            !collapsed && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (test_case_result_module_default()).details,
                children: [
                    testCase.stderr && /*#__PURE__*/ (0,jsx_runtime.jsx)(OutputBlock, {
                        label: "stderr",
                        status: "error",
                        children: testCase.stderr
                    }),
                    testCase.stdout && /*#__PURE__*/ (0,jsx_runtime.jsx)(OutputBlock, {
                        label: "stdout",
                        status: "info",
                        children: testCase.stdout
                    }),
                    !testCase.monte_carlo_simulation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            testCase.output && /*#__PURE__*/ (0,jsx_runtime.jsx)(OutputBlock, {
                                label: "Your code output",
                                status: testCase.success ? "passed" : "failed",
                                children: isDrawableTable(testCase.output) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawableTable, {
                                    data: JSON.parse(testCase.output)
                                }) : testCase.output
                            }),
                            testCase.expected_output && /*#__PURE__*/ (0,jsx_runtime.jsx)(OutputBlock, {
                                label: "Expected output",
                                status: "info",
                                children: isDrawableTable(testCase.expected_output) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawableTable, {
                                    data: JSON.parse(testCase.expected_output)
                                }) : testCase.expected_output
                            }),
                            inputTabs && /*#__PURE__*/ (0,jsx_runtime.jsx)(OutputBlock, {
                                label: "Test Input",
                                status: "info",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tabs */.m, {
                                    size: "sm",
                                    color: "white",
                                    tabs: inputTabs
                                })
                            }),
                            !testCase.success && testCase.strict_row_order && /*#__PURE__*/ (0,jsx_runtime.jsx)(system_alert/* Alert */.b, {
                                type: "warning",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfoIcon */.sz, {}),
                                children: "This test case requires strict row order."
                            })
                        ]
                    }),
                    testCase.monte_carlo_simulation && isMonteCarloSimulation(testCase.expected_output, testCase.output) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MonteCarloSimulation, {
                                success: testCase.success,
                                expectedDistribution: JSON.parse(testCase.expected_output),
                                outputDistribution: JSON.parse(testCase.output)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(system_alert/* Alert */.b, {
                                type: "warning",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfoIcon */.sz, {}),
                                children: [
                                    "This test case is validated using a Monte Carlo simulation (N =",
                                    " ",
                                    testCase.monte_carlo_n,
                                    ", ErrorThreshold = ",
                                    testCase.monte_carlo_error_threshold,
                                    ")."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(system_alert/* Alert */.b, {
                        type: "default",
                        children: [
                            "Execution time:",
                            " ",
                            testCase.runtime < 1000 ? "".concat(testCase.runtime, " ms") : "".concat(testCase.runtime / 1000, " s"),
                            "."
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/runner/code_run_display.tsx







var CodeRunDisplay = function(param) {
    var codeRunResponse = param.codeRunResponse, _collapsed = param.collapsed, collapsed = _collapsed === void 0 ? false : _collapsed, _showUpsell = param.showUpsell, showUpsell = _showUpsell === void 0 ? true : _showUpsell;
    var success = codeRunResponse.success, message = codeRunResponse.message, summary = codeRunResponse.summary, test_cases = codeRunResponse.test_cases;
    var isPlayground = test_cases === null || test_cases === void 0 ? void 0 : test_cases.find(function(tc) {
        return tc.playground;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (code_run_display_module_default()).container,
        children: [
            !isPlayground && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_alert/* Alert */.b, {
                        type: success ? "success" : "error",
                        icon: success ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckmarkIcon */.KM, {
                            color: "white"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                            color: "white"
                        }),
                        children: message
                    }),
                    summary && /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary, {
                        summary: summary
                    })
                ]
            }),
            test_cases === null || test_cases === void 0 ? void 0 : test_cases.map(function(testCase, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestCaseResult, {
                    index: index,
                    testCase: testCase,
                    collapsed: collapsed
                }, index);
            }),
            showUpsell && /*#__PURE__*/ (0,jsx_runtime.jsx)(upsell/* Upsell */.QH, {
                cta: "question.codeRuns",
                barrier: false
            })
        ]
    });
};


/***/ }),

/***/ 56522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44868);
/* harmony import */ var _alert_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44504);
/* harmony import */ var _alert_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_alert_module_css__WEBPACK_IMPORTED_MODULE_3__);




var Alert = function(param) {
    var type = param.type, timeout = param.timeout, icon = param.icon, children = param.children, _onFinish = param.onFinish, onFinish = _onFinish === void 0 ? function() {} : _onFinish;
    var timeoutId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), visible = ref[0], setVisible = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (timeout) {
            timeoutId.current = setTimeout(function() {
                onFinish();
                setVisible(false);
            }, timeout);
        }
        return function() {
            return clearTimeout(timeoutId.current);
        };
    }, [
        type,
        timeout,
        children
    ]);
    return visible ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,utils__WEBPACK_IMPORTED_MODULE_2__/* .classNames */ .AK)([
            (_alert_module_css__WEBPACK_IMPORTED_MODULE_3___default().alert),
            (_alert_module_css__WEBPACK_IMPORTED_MODULE_3___default())[type]
        ]),
        children: [
            icon,
            children
        ]
    }) : null;
};


/***/ }),

/***/ 72734:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"code_run_display_container__Tq1dg","result":"code_run_display_result__57qD_","resultLine":"code_run_display_resultLine__jXzsO","resultError":"code_run_display_resultError__6vKl1","resultSuccess":"code_run_display_resultSuccess__EpEe0","outputBlock":"code_run_display_outputBlock__4HEx1","rowOrder":"code_run_display_rowOrder__p8FK8","stderr":"code_run_display_stderr___STxZ","successOutput":"code_run_display_successOutput__E_6wN","dangerOutput":"code_run_display_dangerOutput__SkFd_"};

/***/ }),

/***/ 75311:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"drawable_table_table__n22eC","null":"drawable_table_null__BQkwv"};

/***/ }),

/***/ 53856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"monte_carlo_simulation_container__orZVu","buckets":"monte_carlo_simulation_buckets__zza_u","legend":"monte_carlo_simulation_legend__4sYqO","expected":"monte_carlo_simulation_expected__USu94","green":"monte_carlo_simulation_green__ETSBM","red":"monte_carlo_simulation_red__yCkNi"};

/***/ }),

/***/ 34828:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"output_block_label__tYsfh","output":"output_block_output__C4VSh","verbatim":"output_block_verbatim__zSVIo","info":"output_block_info__HM_fo","error":"output_block_error__laUnP","passed":"output_block_passed__geul_","failed":"output_block_failed__mIEef"};

/***/ }),

/***/ 31360:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"test_case_result_container__fY9A_","error":"test_case_result_error__ycmZn","success":"test_case_result_success__PLrY4","header":"test_case_result_header__wiXrE","expandCTA":"test_case_result_expandCTA__CvHJl","details":"test_case_result_details__eUOfI","outputBlock":"test_case_result_outputBlock__9RLOh","stderr":"test_case_result_stderr__0NcuC","rowOrder":"test_case_result_rowOrder__CJB_s","successOutput":"test_case_result_successOutput__A4iFt","dangerOutput":"test_case_result_dangerOutput__adQZo"};

/***/ }),

/***/ 44504:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__R1Xm5","error":"alert_error__9Zzn_","warning":"alert_warning__hTmkD","info":"alert_info__Yghzm","success":"alert_success__LLyTL","default":"alert_default__g9281"};

/***/ })

}]);